<template>

    <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>


    <div class="row">

        <div class="col-xl-12 d-flex">
            <div class="card flex-fill">
                <div class="card-header">
                    <h5 class="card-title">Proveedor</h5>
                </div>
                <div class="card-body card-buttons">
                    <form class="needs-validation" novalidate >
                        <div class="row">
                            <div class="col-9">
                                <div class="row">
                                    <div class="col-12 mt-2 input-block">
                                        <label>RIF</label>
                                        <div class="row">
                                            <div class="col-md-3 col-sm-6">
                                                <select v-model="proveedor.tipo_rif" class="form-control"
                                                    :class="{ 'is-invalid': errors.tipo_rif }"
                                                    @change="validateTipoRif">
                                                    <option value="" disabled>Selecciona</option>
                                                    <option value="V">V</option>
                                                    <option value="E">E</option>
                                                    <option value="J">J</option>
                                                    <option value="P">P</option>
                                                    <option value="G">G</option>
                                                </select>
                                                <div class="invalid-feedback">{{ errors.tipo_rif }}</div>
                                            </div>
                                            <div class="col-md-9 col-sm-6">
                                                <b-form-input type="text" v-model="proveedor.rif"
                                                    placeholder="Ej: 12345678" class="form-control"
                                                    :class="{ 'is-invalid': errors.rif }" @input="validateRif" />
                                                <div class="invalid-feedback">{{ errors.rif }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 mt-2 input-block">
                                        <label for="nombre">Razón Social</label>
                                        <b-form-input type="text" v-model="proveedor.nombre" id="nombre"
                                            class="form-control" :class="{ 'is-invalid': errors.nombre }"
                                            @input="validateNombre" />
                                        <div class="invalid-feedback">{{ errors.nombre }}</div>
                                    </div>

                                    <div class="col-6 mt-2 input-block">
                                        <label for="telefono">Teléfono</label>
                                        <b-form-input type="text" v-model="proveedor.telefono" id="telefono"
                                            class="form-control" :class="{ 'is-invalid': errors.telefono }"
                                            @input="validateTelefono" />
                                        <div class="invalid-feedback">{{ errors.telefono }}</div>
                                    </div>

                                    <div class="col-6 mt-2 input-block">
                                        <label for="email">Correo</label>
                                        <b-form-input type="email" v-model="proveedor.email" id="email"
                                            class="form-control" :class="{ 'is-invalid': errors.email }"
                                            @input="validateEmail" />
                                        <div class="invalid-feedback">{{ errors.email }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-3 input-block">
                                <label>Imagen de logo</label>
                                <input class="form-control" type="file" @change="handleImageUpload" accept="image/*" />
                                <div class="mt-1">
                                    <img :src="imagePreview" alt="Vista previa de la imagen" class="img-thumbnail"
                                        style="max-width: 200px; max-height: 200px;" />
                                </div>
                            </div>

                            <div class="col-12 mt-2 input-block">
                                <label for="precio">Dirección</label>
                                <textarea class="form-control" id="" rows="3" placeholder="direccion"
                                    v-model="proveedor.direccion" :class="{ 'is-invalid': errors.direccion }"
                                    @input="validateDireccion"></textarea>
                                <div class="invalid-feedback">{{ errors.direccion }}</div>
                            </div>
                        </div>

                        <div class="text-end mt-3">
                            <b-button @click="saveProveedor" v-if="!isEditing" class="btn-primary m-1">
                                Guardar
                            </b-button>

                            <b-button v-if="isEditing" @click="updateProveedor" 
                                class="btn-edit m-1">Actualizar</b-button>

                            <b-button v-if="isEditing" @click="deleteProveedor"
                                class="btn-danger m-1">Eliminar</b-button>

                            <b-button @click="resetForm" class="btn-clean m-1">Limpiar</b-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-xl-12 d-flex">
            <div class="card super-admin-dash-card">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <h5 class="card-title mb-0">Lista de Proveedores</h5>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="d-flex align-items-center gap-3">
                                <div class="search-box flex-grow-1">
                                    <input
                                        type="text"
                                        v-model="searchTerm"
                                        class="form-control search-input"
                                        placeholder="Buscar por RIF, razón social, teléfono o correo..."
                                    />
                                    <span v-if="searchTerm" class="clear-search" @click="clearSearch">
                                        <i class="fas fa-times"></i>
                                    </span>
                                </div>
                                <span class="text-muted text-nowrap">{{ filteredProveedores.length }} de {{ proveedores.length }} proveedores</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-stripped table-hover">
                            <thead >
                                <tr>
                                    <th>Rif</th>
                                    <th>Razon Social</th>
                                    <th>Telefono</th>
                                    <th>Correo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="paginatedProveedores.length === 0">
                                    <td colspan="4" class="text-center py-4">
                                        <i class="fas fa-inbox fa-3x text-muted mb-3 d-block"></i>
                                        <p class="text-muted mb-0">No se encontraron proveedores{{ searchTerm ? ' con el término de búsqueda' : '' }}</p>
                                    </td>
                                </tr>
                                <tr v-for="proveedor in paginatedProveedores" :key="proveedor.id"
                                    @click="option(proveedor)">
                                    <td>{{ proveedor.tipo_rif }}-{{ proveedor.rif }}</td>
                                    <td>{{ proveedor.nombre }}</td>
                                    <td>{{ proveedor.telefono }}</td>
                                    <td>{{ proveedor.email }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- Paginación -->
                <div class="card-footer" v-if="filteredProveedores.length > 0">
                    <div class="row align-items-center">
                        <div class="col">
                            <p class="mb-0 text-muted">
                                Mostrando {{ rangoInicio }} a {{ rangoFin }} de {{ filteredProveedores.length }} proveedores
                            </p>
                        </div>
                        <div class="col-auto">
                            <nav>
                                <ul class="pagination pagination-sm mb-0">
                                    <li class="page-item" :class="{ disabled: paginacion.paginaActual === 1 }">
                                        <a class="page-link" @click.prevent="cambiarPagina(paginacion.paginaActual - 1)">
                                            <i class="fas fa-chevron-left"></i>
                                        </a>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="pagina in paginasVisibles"
                                        :key="pagina"
                                        :class="{ active: pagina === paginacion.paginaActual }"
                                    >
                                        <a class="page-link" @click.prevent="cambiarPagina(pagina)">
                                            {{ pagina }}
                                        </a>
                                    </li>
                                    <li class="page-item" :class="{ disabled: paginacion.paginaActual === totalPaginas }">
                                        <a class="page-link" @click.prevent="cambiarPagina(paginacion.paginaActual + 1)">
                                            <i class="fas fa-chevron-right"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import user5 from '@/assets/img/user-5.jpg';

export default {
    data() {
        return {
            isLoading: false,
            proveedor: {
                tipo_rif: '',
                rif: '',
                nombre: '',
                telefono: '',
                email: '',
                direccion: '',
            },
            errors: {
                tipo_rif: '',
                rif: '',
                nombre: '',
                telefono: '',
                email: '',
                direccion: '',
                logo: ''
            },
            proveedores: [],
            proveedorId: '',
            baseURL: api.defaults.baseURL,
            imagePreview: user5,
            selectedImage: null,
            isEditing: false,
            searchTerm: '',
            paginacion: {
                paginaActual: 1,
                porPagina: 10
            }
        };
    },
    mounted() {
        this.loadProveedores();
    },

    watch: {
        searchTerm() {
            // Resetear a la primera página cuando se busca
            this.paginacion.paginaActual = 1;
        }
    },

    computed: {
        filteredProveedores() {
            if (!this.searchTerm) {
                return this.proveedores;
            }

            const search = this.searchTerm.toLowerCase().trim();

            return this.proveedores.filter(proveedor => {
                // Buscar en RIF completo
                const rifCompleto = `${proveedor.tipo_rif}-${proveedor.rif}`.toLowerCase();
                const matchRif = rifCompleto.includes(search);

                // Buscar en nombre (razón social)
                const matchNombre = proveedor.nombre?.toLowerCase().includes(search);

                // Buscar en teléfono
                const matchTelefono = proveedor.telefono?.toLowerCase().includes(search);

                // Buscar en email
                const matchEmail = proveedor.email?.toLowerCase().includes(search);

                return matchRif || matchNombre || matchTelefono || matchEmail;
            });
        },
        paginatedProveedores() {
            const inicio = (this.paginacion.paginaActual - 1) * this.paginacion.porPagina;
            const fin = inicio + this.paginacion.porPagina;
            return this.filteredProveedores.slice(inicio, fin);
        },
        totalPaginas() {
            return Math.ceil(this.filteredProveedores.length / this.paginacion.porPagina);
        },
        paginasVisibles() {
            const total = this.totalPaginas;
            const actual = this.paginacion.paginaActual;
            const paginas = [];

            if (total <= 7) {
                for (let i = 1; i <= total; i++) {
                    paginas.push(i);
                }
            } else {
                if (actual <= 4) {
                    for (let i = 1; i <= 5; i++) paginas.push(i);
                    paginas.push('...');
                    paginas.push(total);
                } else if (actual >= total - 3) {
                    paginas.push(1);
                    paginas.push('...');
                    for (let i = total - 4; i <= total; i++) paginas.push(i);
                } else {
                    paginas.push(1);
                    paginas.push('...');
                    for (let i = actual - 1; i <= actual + 1; i++) paginas.push(i);
                    paginas.push('...');
                    paginas.push(total);
                }
            }

            return paginas.filter(p => p !== '...' || paginas.indexOf(p) === paginas.lastIndexOf(p));
        },
        rangoInicio() {
            return (this.paginacion.paginaActual - 1) * this.paginacion.porPagina + 1;
        },
        rangoFin() {
            const fin = this.paginacion.paginaActual * this.paginacion.porPagina;
            return fin > this.filteredProveedores.length ? this.filteredProveedores.length : fin;
        }
    },

    methods: {
        async loadProveedores() {
            try {
                const response = await api.get('/proveedor');
                this.proveedores = response.data;
            } catch (err) {
                this.error = 'Error al cargar proveedores';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },

        handleImageUpload(event) {
            const file = event.target.files[0];
            this.errors.logo = '';

            if (file) {
                // Validar tipo de imagen
                if (!file.type.match('image.*')) {
                    this.errors.logo = 'El archivo debe ser una imagen';
                    return;
                }

                // Validar tamaño de imagen (ejemplo: máximo 2MB)
                if (file.size > 2 * 1024 * 1024) {
                    this.errors.logo = 'La imagen no debe exceder los 2MB';
                    return;
                }

                this.selectedImage = file;
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            } else {
                this.imagePreview = null;
                this.selectedImage = null;
            }
        },

        async saveProveedor() {
            if (!this.validateForm()) {
                this.$toast.error('Por favor complete correctamente todos los campos');
                return;
            }

            const result = await this.$swal.fire({
                title: '¿Guardar Proveedor?',
                text: 'Se guardará un nuevo Proveedor',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, guardar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            const formData = new FormData();
            if (this.selectedImage) {
                formData.append("logo", this.selectedImage);
            }
            formData.append("tipo_rif", this.proveedor.tipo_rif);
            formData.append("rif", this.proveedor.rif);
            formData.append("nombre", this.proveedor.nombre);
            formData.append("telefono", this.proveedor.telefono);
            formData.append("email", this.proveedor.email);
            formData.append("direccion", this.proveedor.direccion);

            try {
                const response = await api.post("/proveedor", formData);
                this.isLoading = false;
                this.$toast.success('Proveedor agregado con éxito');
                this.loadProveedores();
                this.resetForm();
            } catch (error) {
                this.isLoading = false;
                let errorMessage = 'Error al agregar el Proveedor';

                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                this.$toast.error(errorMessage);
            }
        },

        option(proveedor) {

            this.resetForm();

            this.isEditing = true;

            this.proveedorId = proveedor.id;
            this.proveedor.tipo_rif = proveedor.tipo_rif;
            this.proveedor.rif = proveedor.rif;
            this.proveedor.nombre = proveedor.nombre;
            this.proveedor.telefono = proveedor.telefono;
            this.proveedor.email = proveedor.email;
            this.proveedor.direccion = proveedor.direccion;
        },

        async updateProveedor() {

            const result = await this.$swal.fire({
                title: '¿Actualizar Proveedor?',
                text: 'Se modificará el proveedor seleccionado.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, actualizar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;

            this.isLoading = true;

            const formData = new FormData();
            formData.append("tipo_rif", this.proveedor.tipo_rif);
            formData.append("rif", this.proveedor.rif);
            formData.append("nombre", this.proveedor.nombre);
            formData.append("telefono", this.proveedor.telefono);
            formData.append("email", this.proveedor.email);
            formData.append("direccion", this.proveedor.direccion);
            /*
            if (this.selectedImage) {
                formData.append("imagen", this.selectedImage);
            }*/

            try {
                const response = await api.put(`/proveedor/${this.proveedorId}`, formData);
                this.isLoading = false;
                this.$toast.success('Proveedor actualizado con éxito');
                this.resetForm();
                this.loadProveedores();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al actualizar proveedor');
                console.error("Error:", error);
            }
        },
        async deleteProveedor() {

            const result = await this.$swal.fire({
                title: '¿Eliminar proveedor?',
                text: 'Esta acción no se puede deshacer.',
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            try {
                const response = await api.delete(`/proveedor/${this.proveedorId}`);
                this.isLoading = false;
                this.$toast.success('Proveedor eliminada con éxito');
                this.resetForm();
                this.loadProveedores();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al eliminar proveedor');
                console.error("Error:", error);
            }
        },

        validateForm() {
            let isValid = true;

            // Validar tipo de RIF
            if (!this.proveedor.tipo_rif) {
                this.errors.tipo_rif = 'Seleccione un tipo de RIF';
                isValid = false;
            } else {
                this.errors.tipo_rif = '';
            }

            // Validar RIF
            if (!this.proveedor.rif) {
                this.errors.rif = 'El RIF es requerido';
                isValid = false;
            } else if (!/^\d{5,9}$/.test(this.proveedor.rif)) {
                this.errors.rif = 'El RIF debe tener entre 5 y 9 dígitos';
                isValid = false;
            } else {
                this.errors.rif = '';
            }

            // Validar nombre (razón social)
            if (!this.proveedor.nombre.trim()) {
                this.errors.nombre = 'La razón social es requerida';
                isValid = false;
            } else if (this.proveedor.nombre.length < 3) {
                this.errors.nombre = 'La razón social debe tener al menos 3 caracteres';
                isValid = false;
            } else {
                this.errors.nombre = '';
            }

            // Validar teléfono
            if (!this.proveedor.telefono) {
                this.errors.telefono = 'El teléfono es requerido';
                isValid = false;
            } else if (!/^(\+?\d{1,3}[- ]?)?\d{7,15}$/.test(this.proveedor.telefono)) {
                this.errors.telefono = 'Ingrese un teléfono válido';
                isValid = false;
            } else {
                this.errors.telefono = '';
            }

            // Validar email
            if (!this.proveedor.email) {
                this.errors.email = 'El correo es requerido';
                isValid = false;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.proveedor.email)) {
                this.errors.email = 'Ingrese un correo válido';
                isValid = false;
            } else {
                this.errors.email = '';
            }

            // Validar dirección
            if (!this.proveedor.direccion.trim()) {
                this.errors.direccion = 'La dirección es requerida';
                isValid = false;
            } else if (this.proveedor.direccion.length < 10) {
                this.errors.direccion = 'La dirección debe tener al menos 10 caracteres';
                isValid = false;
            } else {
                this.errors.direccion = '';
            }

            return isValid;
        },

        validateTipoRif() {
            if (!this.proveedor.tipo_rif) {
                this.errors.tipo_rif = 'Seleccione un tipo de RIF';
            } else {
                this.errors.tipo_rif = '';
            }
        },

        validateRif() {
            if (!this.proveedor.rif) {
                this.errors.rif = 'El RIF es requerido';
            } else if (!/^\d{5,9}$/.test(this.proveedor.rif)) {
                this.errors.rif = 'El RIF debe tener entre 5 y 9 dígitos';
            } else {
                this.errors.rif = '';
            }
        },

        validateNombre() {
            if (!this.proveedor.nombre.trim()) {
                this.errors.nombre = 'La razón social es requerida';
            } else if (this.proveedor.nombre.length < 3) {
                this.errors.nombre = 'La razón social debe tener al menos 3 caracteres';
            } else {
                this.errors.nombre = '';
            }
        },

        validateTelefono() {
            if (!this.proveedor.telefono) {
                this.errors.telefono = 'El teléfono es requerido';
            } else if (!/^(\+?\d{1,3}[- ]?)?\d{7,15}$/.test(this.proveedor.telefono)) {
                this.errors.telefono = 'Ingrese un teléfono válido';
            } else {
                this.errors.telefono = '';
            }
        },

        validateEmail() {
            if (!this.proveedor.email) {
                this.errors.email = 'El correo es requerido';
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.proveedor.email)) {
                this.errors.email = 'Ingrese un correo válido';
            } else {
                this.errors.email = '';
            }
        },

        validateDireccion() {
            if (!this.proveedor.direccion.trim()) {
                this.errors.direccion = 'La dirección es requerida';
            } else if (this.proveedor.direccion.length < 10) {
                this.errors.direccion = 'La dirección debe tener al menos 10 caracteres';
            } else {
                this.errors.direccion = '';
            }
        },

        resetForm() {
            this.proveedor = {
                tipo_rif: '',
                rif: '',
                nombre: '',
                telefono: '',
                email: '',
                direccion: '',
                logo: undefined
            };
            this.imagePreview = user5;
            this.selectedImage = null;
            this.isEditing = false;

            // Limpiar errores
            Object.keys(this.errors).forEach(key => {
                this.errors[key] = '';
            });
        },

        clearSearch() {
            this.searchTerm = '';
            this.paginacion.paginaActual = 1;
        },

        cambiarPagina(pagina) {
            if (pagina >= 1 && pagina <= this.totalPaginas) {
                this.paginacion.paginaActual = pagina;
                // Scroll to top of table
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }
};
</script>
<style>
.is-invalid {
    border-color: #dc3545;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
}

/* Estilos del buscador */
.search-box {
    position: relative;
    display: flex;
    align-items: center;
}

.search-input {
    padding-left: 12px;
    padding-right: 38px;
    border-radius: 8px;
    border: 1px solid #dee2e6;
    transition: all 0.3s ease;
    width: 100%;
}

.search-input:focus {
    border-color: #4e73df;
    box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.15);
}

.clear-search {
    position: absolute;
    right: 12px;
    color: #6c757d;
    cursor: pointer;
    z-index: 1;
    padding: 4px;
    transition: color 0.2s;
}

.clear-search:hover {
    color: #dc3545;
}

/* Estilos de paginación */
.pagination {
    gap: 0.25rem;
}

.page-link {
    border-radius: 0.25rem;
    border: 1px solid #dee2e6;
}

.page-item.active .page-link {
    background-color: #0d6efd;
    border-color: #0d6efd;
}

/* Mejorar hover de filas */
tbody tr {
    cursor: pointer;
    transition: background-color 0.2s;
}

tbody tr:hover {
    background-color: #f8f9fa;
}
</style>